import { render, staticRenderFns } from "./privacyAgr.vue?vue&type=template&id=33e22790&scoped=true"
import script from "./privacyAgr.vue?vue&type=script&lang=js"
export * from "./privacyAgr.vue?vue&type=script&lang=js"
import style0 from "./privacyAgr.vue?vue&type=style&index=0&id=33e22790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e22790",
  null
  
)

export default component.exports